import { useStore } from 'effector-react'
import * as React from 'react'

import { $clientBonusAccountEdit, clientBonusAccountEditMounted } from './model'

export const useClientBonusAccountEdit = () => {
  const clientBonusAccountEdit = useStore($clientBonusAccountEdit)

  React.useEffect(() => {
    clientBonusAccountEditMounted()
  }, [])

  return clientBonusAccountEdit
}
